import { render, staticRenderFns } from "./MySQLIntegration.vue?vue&type=template&id=2b22522c&scoped=true&"
import script from "./MySQLIntegration.vue?vue&type=script&lang=ts&"
export * from "./MySQLIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22522c",
  null
  
)

export default component.exports